module.exports = __webpack_public_path__ + "img/icons.379a5f1a.svg";